module.exports = __webpack_public_path__ + "static/media/18ECA35.9c1d7c78.jpg";